import { render, staticRenderFns } from "./ProductReportTable.vue?vue&type=template&id=383cffaa&"
import script from "./ProductReportTable.vue?vue&type=script&lang=js&"
export * from "./ProductReportTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductReportTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports